<template lang="pug">
    footer
        .container.mx-auto
            .footer-wrap
                .left
                    .box.logo
                        img(v-if="logo && logo.id", :src="image.src", alt="NEW-GOL", rel="noopener")
                    .box.address
                        p <strong>NEW G.O.L. GmbH</strong><br>
                          | Grünewaldstraße 49–51<br>
                          | D-63834 Sulzbach/Main
                        p <strong>T</strong> <a href="tel:0049602812080">+49 (0) 6028 12 08-0</a><br>
                          |<strong>F</strong> <a href="fax:00496028120899">+49 (0) 6028 12 08-99</a>
                        p <a href="mailto:info@newgol.de">info@newgol.de</a>
                .right
                    .box.nav
                        Menu#footer-nav(k="footer-menu", :max-depth="1")
                    .box.social
                        ul.social-links
                            li
                                a(href="https://www.facebook.com/NEWGOLSulzbach", target="_blank", title="Facebook: NEW GOL" rel="noopener")
                                  span.icon
                                    font-awesome-icon(:icon="['fab', 'facebook-f']")
                            li
                                a(href="https://instagram.com/", target="_blank", title="Instagram", rel="noopener")
                                  span.icon
                                    font-awesome-icon(:icon="['fab', 'instagram']")
</template>

<script>
import { mapGetters } from 'vuex';
import { trim } from '@/helpers';
import Menu from '@/components/Menu.vue';

export default {
    name: 'Footer',
    components: {
        Menu
    },
    data() {
        return {
            scTimer: 0,
            scY: 0
        };
    },
    computed: {
        image() {
            const storageRoute = trim(
                `${process.env.VUE_APP_API_HTTP}${process.env.VUE_APP_API_ENDPOINT}${process.env.VUE_APP_API_PUBLIC_STORAGE_ROUTE}`,
                '/'
            );

            const fit = 'fit&w=150';

            let width = this.logo.width;
            let height = this.logo.height;

            return {
                src: `${storageRoute}/images/${this.logo.id}/${this.logo.name}?${fit}`,
                error: `${storageRoute}/images/${this.logo.id}/${this.logo.name}?${fit}&preview=greyscale`,
                loading: `${storageRoute}/images/${this.logo.id}/${this.logo.name}?${fit}&preview=blur`,
                width,
                height
            };
        },
        ...mapGetters({
            logo: 'logo',
            menus: 'menus',
            config: 'config'
        })
    },
    mounted() {
        window.addEventListener('scroll', this.handleScroll);
    },

    methods: {
        handleScroll: function() {
            if (this.scTimer) return;
            this.scTimer = setTimeout(() => {
                this.scY = window.scrollY;
                clearTimeout(this.scTimer);
                this.scTimer = 0;
            }, 100);
        },
        toTop: function() {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        }
    }
};
</script>

<style lang="sass" nolang="scss" scoped>
@import "~@/assets/sass/variables"

footer
    @apply block bottom-0 w-full text-white mt-12
    background-color: $color-primary
    .footer-wrap
        @apply flex justify-between py-8
        flex-direction: column
        @screen sm
            flex-direction: row
        > div
            @apply block w-full
            @screen sm
                @apply w-auto flex justify-between
        .right
            @apply flex-col
        .box
            @apply w-full text-center
            @screen sm
                @apply w-auto text-left

        .logo
            @apply hidden
            margin-top: -2rem
            background-color: $color-secondary
            width: 100px
            height: 116px
            @screen lg
                @apply block

        .address
            @screen lg
                @apply ml-12
            .trademark
                @apply relative
                font-size: 10px
                top: -5px
                left: -2px
            p
                @apply mb-2
                &:last-of-type
                    @apply mb-0
                a
                    @apply transition-colors duration-200 ease-in-out
                    text-shadow: -.25px -.25px 0 transparent, .25px .25px transparent
                    &:hover
                        color: $color-hover-header-menu
                        text-shadow: -.25px -.25px 0 #fff, .25px .25px #fff
        .nav ::v-deep
            @apply mt-8
            @screen sm
                @apply mr-0 mt-0

            #footer-nav
                .tree-menu
                    @screen sm
                        @apply flex flex-col
                    a
                        @apply transition-colors duration-200 ease-in-out block
                        text-shadow: -.25px -.25px 0 transparent, .25px .25px transparent
                        margin-bottom: 0.25rem
                        &:before
                            font-weight: 700
                        &:hover
                            color: $color-hover-header-menu
                            text-shadow: -.25px -.25px 0 #fff, .25px .25px #fff
                    & > li
                         &.active
                            @apply font-bold
        .social
            @apply mt-6
            @screen sm
                @apply mt-0
            .social-links
                margin: 0 auto
                li
                  @apply inline-block mr-3
                  &:last-of-type
                    @apply mr-0
                  &:hover .icon
                    @apply border-white text-white
                    background-color: $color-primary
                  .icon
                    @apply flex text-2xl bg-white border-2 border-white border-solid justify-center items-center rounded-full transition-colors duration-200 ease-in-out
                    color: $color-primary
                    width: 40px
                    height: 40px
</style>
